import { connect } from 'react-redux';

import { trackShowPhone } from '../../actions/analytics';
import { LastHopePopup, ILastHopePopupProps } from '../../components/LastHopePopup';
import { LIMIT_IN_A_DAY } from '../../constants/lastHopePopup';
import { getBuilders } from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';
import {
  isPopupHistoryExpired,
  resetPopupShowingsHistory,
  isUserOpenedPhoneInNewobject,
  isShowingsLimitReached,
} from '../../utils/businessLogic/lastHopePopup';
import { getGaLabel } from '../../selectors/analytics';

export function mapStateToProps(state: TApplicationState): ILastHopePopupProps {
  // Незамокать отсутствие window
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return {
      isDefaultOpen: () => false,
      onShowPhoneClick: () => false,
      builderName: null,
    };
  }

  const {
    newbuilding: { fromDevelopersPropsCount, id },
  } = state;
  const builders = getBuilders(state);
  const builderWithPhones = builders.find(builder => builder.phone && builder.phone.number);

  const gaLabel = getGaLabel(state);

  /* istanbul ignore next */
  if (isPopupHistoryExpired(24)) {
    resetPopupShowingsHistory();
  }

  return {
    builderName: builderWithPhones ? builderWithPhones.name : null,
    isDefaultOpen: () =>
      fromDevelopersPropsCount !== 0 &&
      !!builderWithPhones &&
      !isUserOpenedPhoneInNewobject(id) &&
      !isShowingsLimitReached(LIMIT_IN_A_DAY, 24),
    onShowPhoneClick: () => trackShowPhone(gaLabel, 'Open_ask_builder_popup'),
  };
}

export const LastHopePopupContainer = connect(mapStateToProps)(LastHopePopup);
